import { SvgIconProps } from './icon-props';

export default function Diamond({ height = 32, width = 32 }: SvgIconProps) {
	return (
		<svg
			width={width}
			height={height}
			viewBox="2.0196 1.87735 28.2451 28.24505"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M2.13302 16.1097C2.01961 16.0804 2.0196 15.9193 2.13302 15.8901L9.9431 13.8739C11.9407 13.3583 13.5005 11.7984 14.0162 9.80084L16.0323 1.99077C16.0616 1.87735 16.2227 1.87735 16.2519 1.99077L18.2681 9.80084C18.7837 11.7984 20.3436 13.3583 22.3412 13.874L30.1512 15.8901C30.2647 15.9193 30.2647 16.0804 30.1512 16.1097L22.3412 18.1258C20.3436 18.6415 18.7837 20.2013 18.2681 22.1989L16.2519 30.009C16.2227 30.1224 16.0616 30.1224 16.0323 30.009L14.0162 22.1989C13.5005 20.2014 11.9407 18.6415 9.9431 18.1258L2.13302 16.1097Z" />
		</svg>
	);
}
